import React from 'react';
import { format } from 'date-fns';
import { Dialog } from '@mui/material';
import TimeSlotGrid from '../../../manual-booking/components/booking/steps/TimeSlotGrid';
import './styles/MeetingRescheduleDialog.css';

const MeetingRescheduleDialog = ({
  open,
  onClose,
  currentStartDate,
  selectedDateValue,
  selectedTime,
  timeSlots,
  onDateChange,
  onTimeSelect,
  reason,
  onReasonChange,
  onSubmit,
  isMobile = false,
  rescheduling = false,
  error = '',
}) => {
  const minDate = format(new Date(), 'yyyy-MM-dd');

  return (
    <Dialog
      open={open}
      onClose={rescheduling ? undefined : onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ className: 'meeting-reschedule-dialog__paper' }}
    >
      <div className="meeting-reschedule-dialog meeting-form">
        <button
          type="button"
          className="meeting-reschedule-dialog__close"
          onClick={onClose}
          disabled={rescheduling}
          aria-label="Close reschedule dialog"
        >
          ×
        </button>

        <div className="meeting-reschedule-dialog__body">
          <div className="meeting-reschedule-dialog__top-grid">
            {currentStartDate && (
              <section className="meeting-reschedule-dialog__panel meeting-reschedule-dialog__panel--current">
                <span className="meeting-reschedule-dialog__label">Current meeting time</span>
                <p className="meeting-reschedule-dialog__current-time">
                  {format(currentStartDate, 'MMM d, yyyy, h:mm a')}
                </p>
              </section>
            )}

            <section className="meeting-reschedule-dialog__panel">
              <label className="meeting-reschedule-dialog__label" htmlFor="meeting-reschedule-date">
                New date
              </label>
              <input
                id="meeting-reschedule-date"
                type="date"
                className="meeting-form__input"
                value={selectedDateValue}
                min={minDate}
                onChange={onDateChange}
                disabled={rescheduling}
                aria-label="Reschedule date"
              />
            </section>
          </div>

          <section className="meeting-reschedule-dialog__panel">
            <div className="meeting-reschedule-dialog__slots-header">
              <span className="meeting-reschedule-dialog__label">Available time slots</span>
              {selectedTime && (
                <span className="meeting-reschedule-dialog__selection">
                  Selected: {format(selectedTime, 'h:mm a')}
                </span>
              )}
            </div>
            {selectedDateValue ? (
              timeSlots.length ? (
                <div className="meeting-reschedule-dialog__slots-grid">
                  <TimeSlotGrid
                    timeSlots={timeSlots}
                    selectedTime={selectedTime}
                    onTimeSelect={onTimeSelect}
                    isMobile={isMobile}
                    disabled={rescheduling}
                  />
                </div>
              ) : (
                <p className="meeting-reschedule-dialog__hint">
                  No available slots for this date.
                </p>
              )
            ) : (
              <p className="meeting-reschedule-dialog__hint">
                Choose a date to load available time slots.
              </p>
            )}
          </section>

          <section className="meeting-reschedule-dialog__panel">
            <label className="meeting-reschedule-dialog__label" htmlFor="meeting-reschedule-reason">
              Reschedule reason (optional)
            </label>
            <textarea
              id="meeting-reschedule-reason"
              className="meeting-form__textarea meeting-reschedule-dialog__textarea"
              value={reason}
              onChange={onReasonChange}
              disabled={rescheduling}
              rows={3}
              placeholder="Add any context for why this meeting is being rescheduled."
            />
          </section>

          {error && <p className="meeting-reschedule-dialog__error">{error}</p>}
        </div>

        <div className="meeting-reschedule-dialog__actions">
          <button
            type="button"
            className="meeting-reschedule-dialog__button meeting-reschedule-dialog__button--secondary"
            onClick={onClose}
            disabled={rescheduling}
          >
            Cancel
          </button>
          <button
            type="button"
            className="meeting-reschedule-dialog__button meeting-reschedule-dialog__button--primary"
            onClick={onSubmit}
            disabled={rescheduling || !selectedTime}
          >
            {rescheduling ? 'Rescheduling...' : 'Save reschedule'}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default MeetingRescheduleDialog;
